import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesPoligrafo: [],
    evaluacionesPoligrafoExpediente: [],
  },

  getters: {
    getEvaluacionesPoligrafo: (state) => state.evaluacionesPoligrafoExpediente,
  },

  mutations: {
    SET_EVALUACIONES_POLIGRAFO(state, evaluacionesPoligrafo) {
      state.evaluacionesPoligrafo = evaluacionesPoligrafo;
    },

    SET_EVALUACIONES_POLIGRAFO_EXPEDIENTE(state, evaluacionesPoligrafoExpediente) {
      state.evaluacionesPoligrafoExpediente = evaluacionesPoligrafoExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesPoligrafo({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionespoligrafo')
        .then((response) => {
          commit('SET_EVALUACIONES_POLIGRAFO', response.data.data);
        });
    },

    async fetchEvaluacionesPoligrafoByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionespoligrafo`)
        .then((response) => {
          commit('SET_EVALUACIONES_POLIGRAFO_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionPoligrafo(context, evaluacionPoligrafo) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionPoligrafo.fk_idExpediente}/evaluacionespoligrafo`, evaluacionPoligrafo)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación de polígrafo realizada correctamente', {
            root: true,
          });
        });
    },

    async updateEvaluacionPoligrafo(_, evaluacionPoligrafo) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${evaluacionPoligrafo.fk_idDerivacion}/evaluacionespoligrafo`, evaluacionPoligrafo);
    },
  },
};
